export default array => [...new Set(array)].join(' ')